function InsuranceMenu({ handletabs, activeTab }) {
  return (
    <div className="c-mid-bdy-hdr clear-top10">
      <span
        className={
          activeTab === 'insurance'
            ? 'widget-hdr-title h-active-t'
            : 'widget-hdr-title'
        }
        onClick={() => handletabs('insurance')}
      >
        Insurance
      </span>

      <span
        className={
          activeTab === 'priorauth'
            ? 'widget-hdr-title h-active-t'
            : 'widget-hdr-title'
        }
        onClick={() => handletabs('priorauth')}
      >
        Prior Authorization
      </span>
    </div>
  );
}

export default InsuranceMenu;
